<template>
	<add ref="add" :IsShow="1" @setConfig="setConfig"></add>
</template>
<script>
import add from "@/views/apply/newVip/card/vip/add";
import { mapGetters } from "vuex";
import {
	visitor_discount_setConfig,
} from "@/api/vip";
export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	components: {
		add,
	},
	data() {
		return {};
	},
	methods: {
		async setConfig(val, data) {
			console.log(val, data);
			if (val == "add") {
				const res = await visitor_discount_setConfig(data);
				if (res.code == 200) {
					this.$message.success(res.msg);
          this.$refs.add.sanke_info()
				} else {
					this.$message.error(res.msg);
				}
			}
		},
	},
};
</script>
